module.exports = __webpack_public_path__ + "static/img/tuzheng_04.aaa76dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tuzheng_04.png
// module id = pwui
// module chunks = 1